class NSSProductCarousel extends HTMLElement {

  constructor() {
    super();

    this.debug = false;

    this.swiper;
  }

  connectedCallback() {
    if (this.debug) console.log("[NSS][Product Carousel] Connected.");

    const carouselEl = this.querySelector(`.swiper`);

    this.swiper = new Swiper(carouselEl, {
      autoHeight: true,
      grabCursor: true,
      slidesPerView: 1.3,
      spaceBetween: 20,

      breakpoints: {
        414: {
          slidesPerView: 1.8,
        },
        750: {
          slidesPerView: 2.8,
        },
        990: {
          slidesPerView: 4,
        },
      },

      a11y: {
        enabled: true,
      },
    
      navigation: {
        prevEl: '.nss-product-carousel-prev',
        nextEl: '.nss-product-carousel-next',
      },
    
      scrollbar: {
        el: '.nss-product-carousel-scrollbar',
        draggable: true,
      },
    });

    const editorEvents = [
      `shopify:inspector:activate`,
      `shopify:inspector:deactivate`,
      `shopify:section:load`,
      `shopify:section:unload`,
      `shopify:section:select`,
      `shopify:section:deselect`,
      `shopify:section:reorder`,
      `shopify:block:select`,
      `shopify:block:deselect`,
    ]
    editorEvents.forEach((event) => {
      this.addEventListener(event, this.handleEditorEvent.bind(this));
    });

  }

  handleEditorEvent(e) {
    if (this.debug) console.log("[NSS][Product Carousel] Handle editor event, e:", e);

    switch(e.type) {

      case `shopify:block:select`:
        const blockEl = this.querySelector(`[data-block-id="${e.detail.blockId}"]`);
        const slideEl = blockEl.closest(`.swiper-slide`);
        if (this.debug) console.log("[NSS][Product Carousel] slideEl:", slideEl);
        if (slideEl) {
          // const index = slideEl.getAttribute(`data-swiper-slide-index`);
          const slideEls = [...this.querySelectorAll(`.swiper-slide`)];
          const index = slideEls.indexOf(slideEl);
          if (this.debug) console.log("[NSS][Product Carousel] Sliding to index:", index);
          this.swiper.slideTo(index);
        }
        break;

    }
  }
}

let elementName = `nss-product-carousel`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSProductCarousel);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`)
}